import { Skeleton } from "@mui/material";

interface ChatSidebarSkeletonProps {
  isChatGroupsLoading?: boolean;
  isCompanyUsersLoading?: boolean;
}

const ChatSidebarSkeleton = ({
  isChatGroupsLoading,
  isCompanyUsersLoading,
}: ChatSidebarSkeletonProps) => {
  return (
    <div className="tw-space-y-3">
      {isCompanyUsersLoading &&
        [1, 2, 3].map((item) => (
          <div
            key={item}
            className="tw-w-80 tw-bg-[#ECF1F8] tw-rounded-xl tw-p-3 tw-mb-3"
          >
            {/* Company Header Skeleton */}
            <div className="tw-flex tw-justify-between tw-items-center tw-p-2">
              <div className="tw-flex tw-items-center tw-gap-2">
                <Skeleton variant="circular" width={16} height={16} />
                <Skeleton variant="text" width={120} height={24} />
              </div>
              <Skeleton variant="text" width={40} height={24} />
            </div>

            {/* Users List Skeleton */}
            <div className="tw-mt-2 tw-space-y-2">
              {[1, 2, 3].map((user) => (
                <div
                  key={user}
                  className="tw-flex tw-items-center tw-gap-3 tw-p-2"
                >
                  <Skeleton variant="circular" width={25} height={25} />
                  <Skeleton variant="text" width={100} height={24} />
                </div>
              ))}
            </div>
          </div>
        ))}

      {/* Groups Section Skeleton */}
      {isChatGroupsLoading && (
        <div className="tw-w-80 tw-bg-[#ECF1F8] tw-rounded-xl tw-p-3 tw-mt-3">
          <div className="tw-flex tw-justify-between tw-items-center tw-p-2">
            <div className="tw-flex tw-items-center tw-gap-2">
              <Skeleton variant="circular" width={16} height={16} />
              <Skeleton variant="text" width={80} height={24} />
            </div>
            <Skeleton variant="text" width={60} height={24} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatSidebarSkeleton;
